import { render } from "./verify-account.vue?vue&type=template&id=2f459d0c&scoped=true"
import script from "./verify-account.vue?vue&type=script&lang=js"
export * from "./verify-account.vue?vue&type=script&lang=js"

import "./verify-account.vue?vue&type=style&index=0&id=2f459d0c&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f459d0c"]])

export default __exports__